import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-groups-config',
  templateUrl: './d-groups-config.component.html',
  styles: []
})
export class DGroupsConfigComponent extends DynamicComponentBase {
  static KEY = 'd-group-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    // if (!Array.isArray(config.value)) {
    //   config.value = [];
    // }
  }
}
